(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-gracias"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var el = document.querySelector('[data-mt-gracias]');
    if (!el) return;
    var params = new URLSearchParams(window.location.search);
    function leer(atributo) {
      var nombreParam = el.getAttribute(atributo);
      if (!nombreParam) return '';
      return (params.get(nombreParam) || '').trim().slice(0, 80);
    }
    var datos = {
      pedido: leer('data-p-pedido').replace(/^#/, ''),
      nombre: leer('data-p-nombre'),
      cantidad: leer('data-p-cantidad'),
      total: leer('data-p-total'),
      producto: el.getAttribute('data-producto') || ''
    };
    function rellenar(plantilla) {
      return (plantilla || '').replace(/\{(\w+)\}/g, function (_, clave) {
        return datos[clave] || '';
      });
    }

    if (datos.nombre) {
      var titulo = el.querySelector('.mt-gracias__titulo');
      var conNombre = el.getAttribute('data-titulo-con-nombre');
      if (titulo && conNombre) titulo.textContent = rellenar(conNombre);
    }

    var mensaje = datos.pedido
      ? rellenar(el.getAttribute('data-plantilla'))
      : rellenar(el.getAttribute('data-plantilla-sin-datos'));
    var telefono = (el.getAttribute('data-telefono') || '').replace(/\D/g, '');
    var boton = el.querySelector('.mt-gracias__boton');
    if (boton && telefono) {
      boton.href = 'https://wa.me/' + telefono + '?text=' + encodeURIComponent(mensaje);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-producto"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var conf = document.querySelector('[data-mt-cod-config]');

    // Cualquier .mt-abrir-cod (barra móvil, botones "Pedir ahora" de otras
    // secciones) abre el formulario de la app COD o baja hasta él.
    document.addEventListener('click', function (ev) {
      var boton = ev.target.closest('.mt-abrir-cod');
      if (!boton || !conf) return;
      ev.preventDefault();
      var selector = conf.getAttribute('data-selector');
      if (selector) {
        var botonApp = document.querySelector(selector);
        if (botonApp) {
          botonApp.click();
          return;
        }
      }
      var destino = document.querySelector(conf.getAttribute('data-destino'));
      if (destino) destino.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    // Galería: contador y miniaturas sobre el carrusel con scroll-snap.
    var track = document.querySelector('[data-mt-track]');
    var contador = document.querySelector('[data-mt-contador]');
    var minis = Array.prototype.slice.call(document.querySelectorAll('[data-mt-mini]'));
    if (track && minis.length) {
      track.addEventListener(
        'scroll',
        function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          if (contador) contador.textContent = i + 1 + ' / ' + minis.length;
          minis.forEach(function (m, j) {
            m.setAttribute('aria-current', j === i ? 'true' : 'false');
          });
        },
        { passive: true }
      );
      minis.forEach(function (m) {
        m.addEventListener('click', function () {
          var i = parseInt(m.getAttribute('data-mt-mini'), 10);
          track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        });
      });
    }

    // Fechas de entrega: días hábiles (lunes a sábado) desde hoy.
    var entrega = document.querySelector('[data-mt-entrega]');
    if (entrega && entrega.getAttribute('data-fechas') === 'true') {
      var sumar = function (n) {
        var d = new Date();
        while (n > 0) {
          d.setDate(d.getDate() + 1);
          if (d.getDay() !== 0) n--;
        }
        return d;
      };
      var dMin = sumar(parseInt(entrega.getAttribute('data-min'), 10));
      var dMax = sumar(parseInt(entrega.getAttribute('data-max'), 10));
      var largo = new Intl.DateTimeFormat('es-GT', { weekday: 'long', day: 'numeric', month: 'long' });
      var corto = new Intl.DateTimeFormat('es-GT', { day: 'numeric', month: 'short' });
      var fMin = entrega.querySelector('[data-mt-fecha-min]');
      var fMax = entrega.querySelector('[data-mt-fecha-max]');
      var rango = entrega.querySelector('[data-mt-rango]');
      if (fMin) fMin.textContent = largo.format(dMin);
      if (fMax) fMax.textContent = largo.format(dMax);
      if (rango) rango.textContent = corto.format(dMin).replace('.', '') + ' – ' + corto.format(dMax).replace('.', '');
    }

    // Barra móvil: se esconde mientras el formulario COD está en pantalla.
    var barra = document.querySelector('[data-mt-barra]');
    var destino = conf && document.querySelector(conf.getAttribute('data-destino'));
    if (barra && destino && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entradas) {
          barra.classList.toggle('mt-oculta', entradas[0].isIntersecting);
        },
        { threshold: 0.2 }
      ).observe(destino);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
